import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {
  zadCategoriesUrl,
  zadCategoryByIdUrl,
  zadCategoryStatusUrl,
  zadCategoryUpdateUrl,
} from '../../api'
import {buildZadListQuery} from '../zad/query'
import {parseZadApiError} from '../zad/errors'
import {
  CreateZadCategoryRequest,
  FetchZadCategoriesRequest,
  FetchZadCategoryByIdRequest,
  UpdateZadCategoryRequest,
  UpdateZadCategoryStatusRequest,
} from './types'

export const fetchZadCategories = createAsyncThunk(
  'zadCategories/fetch',
  async (payload: FetchZadCategoriesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${zadCategoriesUrl}?${buildZadListQuery(payload)}`)
      const {categories, total, totalPages} = res.data || {}
      return {
        success: true as const,
        categories: Array.isArray(categories) ? categories : [],
        total: typeof total === 'number' ? total : 0,
        totalPages: typeof totalPages === 'number' ? totalPages : 0,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadCategoryOptions = createAsyncThunk(
  'zadCategories/fetchOptions',
  async (_payload: void, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${zadCategoriesUrl}?${buildZadListQuery({
          pageNumber: 1,
          pageCount: 100,
          sortField: 'name',
          sortOrder: 'asc',
        })}`
      )
      const {categories} = res.data || {}
      return {
        success: true as const,
        categories: Array.isArray(categories) ? categories : [],
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadCategoryById = createAsyncThunk(
  'zadCategories/fetchById',
  async (payload: FetchZadCategoryByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadCategoryByIdUrl(payload.id))
      return {
        success: true as const,
        category: res.data.category,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const createZadCategory = createAsyncThunk(
  'zadCategories/create',
  async (payload: CreateZadCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadCategoriesUrl, payload)
      return {
        success: true as const,
        category: res.data.category,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadCategory = createAsyncThunk(
  'zadCategories/update',
  async (payload: UpdateZadCategoryRequest, {rejectWithValue}) => {
    try {
      const {id, ...body} = payload
      const res = await axios.post(zadCategoryUpdateUrl(id), body)
      return {
        success: true as const,
        category: res.data.category,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadCategoryStatus = createAsyncThunk(
  'zadCategories/updateStatus',
  async (payload: UpdateZadCategoryStatusRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadCategoryStatusUrl(payload.id), {
        isActive: payload.isActive,
      })
      return {
        success: true as const,
        category: res.data.category,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
